"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

/* eslint-disable */
var _default = function _default() {
  !function (e, t, r, n, a) {
    if (!e[a]) {
      for (var i = e[a] = [], c = 0; c < r.length; c++) {
        var s = r[c];

        i[s] = i[s] || function (e) {
          return function () {
            var t = Array.prototype.slice.call(arguments);
            i.push([e, t]);
          };
        }(s);
      }

      i.SNIPPET_VERSION = '1.0.1';
      var o = t.createElement('script');
      o.type = 'text/javascript', o.async = !0, o.src = 'https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/' + n + '/' + a + '.js';
      var p = t.getElementsByTagName('script')[0];
      p.parentNode.insertBefore(o, p);
    }
  }(window, document, ['survey', 'reset', 'config', 'init', 'set', 'get', 'event', 'identify', 'track', 'page', 'screen', 'group', 'alias'], 'p8OHTRo7DOc3p9uF', 'delighted');
  var surveyData = {
    name: window.inSidedData.user.name,
    email: window.inSidedData.user.email,
    properties: {
      customerName: (0, _globals.default)('communityId'),
      userId: window.inSidedData.user.userid,
      userEmail: window.inSidedData.user.email,
      userName: window.inSidedData.user.name,
      userPrimaryRole: window.inSidedData.user.mainRole,
      userRoles: window.inSidedData.user.role
    }
  };
  /** global: delighted */

  delighted.survey(surveyData);
};

exports.default = _default;